import { render, staticRenderFns } from "./RewardCell.vue?vue&type=template&id=fca6647a&scoped=true&"
import script from "./RewardCell.vue?vue&type=script&lang=ts&"
export * from "./RewardCell.vue?vue&type=script&lang=ts&"
import style0 from "./RewardCell.vue?vue&type=style&index=0&id=fca6647a&lang=scss&scoped=true&"
import style1 from "./RewardCell.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca6647a",
  null
  
)

export default component.exports